import './ErrorScreen.scss';

interface Props {
  title: string;
}

export const ErrorScreen = (props: Props) => <div className="error-screen">Error: {props.title}</div>;
